import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import Head from '../../components/Partials/Head/Head';
import Auxiliary from '../../hoc/Auxiliary';
import ServiceBanner from '../../components/ServiceBanner/ServiceBanner';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import TextGroup from '../../components/TextGroup/TextGroup';
import CTA from '../../components/CTA/CTA';
import Video from '../../components/Video/Video';
class EmbeddedRecruitment extends Component {

  render() {
    return (
      <Auxiliary>
        <Head {...this.props} id="embeddedRecruitment" />
        <ServiceBanner {...this.props} page="embeddedRecruitment" />
        <ServiceSection noPadTitle noTitle noPadBottom {...this.props} page="embeddedRecruitment" >
          <Video {...this.props} page="embeddedRecruitment" />
        </ServiceSection>
        <ServiceSection noPadBottom {...this.props} page="embeddedRecruitment" section="objectives">
          <TextGroup {...this.props} page="embeddedRecruitment" section="objectives" />
        </ServiceSection>
        <ServiceSection noPadTitle noPadBottom {...this.props} page="embeddedRecruitment" section="benefits">
          <TextGroup {...this.props} page="embeddedRecruitment" section="benefits" />
        </ServiceSection>
        <ServiceSection noPadBottom {...this.props} page="embeddedRecruitment" section="methodology">
          <TextGroup {...this.props} page="embeddedRecruitment" section="methodology" />
        </ServiceSection>
        <ServiceSection noTitle {...this.props} page="embeddedRecruitment">
          <CTA noBG {...this.props} />
        </ServiceSection>
      </Auxiliary>
    )
  }
}

export default withTranslation()(EmbeddedRecruitment);